export default __webpack_public_path__ + "static/media/G0860.Breech_semirecum_manage4.1692879900000.d14736db.jpg";